import React, { useEffect, useState } from "react";
import axios from "axios";
import BookCreateModal from "./BookCreateModal";

const Book = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [books, setBooks] = useState([]);

  const fetchBooks = async () => {
    try {
      const response = await axios.get(
        `${import.meta.env.VITE_API_BASE_URL}/api/books`
      );
      setBooks(response.data);
    } catch (err) {
      console.error("Failed to fetch books", err.response?.data || err.message);
    }
  };

  useEffect(() => {
    fetchBooks();
  }, []);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this book?"
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("token");

      await axios.delete(
        `${import.meta.env.VITE_API_BASE_URL}/api/books/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Refresh books after deletion
      fetchBooks();
    } catch (error) {
      console.error("Delete failed:", error.response?.data || error.message);
      alert("Failed to delete the book.");
    }
  };

  return (
    <div className="w-full flex flex-col gap-8">
      <div className="w-full flex flex-col gap-4 bg-[#00294B] rounded-md">
        <h2 className="px-4 pt-4 text-2xl font-bold text-white">Books</h2>
        <div className="w-full flex items-center justify-end gap-4 border-b border-[#22BEFF33] px-4">
          <button
            className="py-1 px-4 bg-[#22BEFF] text-black rounded cursor-pointer font-semibold"
            onClick={() => setIsModalOpen(true)}
          >
            Create
          </button>
        </div>

        <div className="w-full flex flex-col gap-4 p-4 min-h-[20rem]">
          {books.length === 0 ? (
            <h4 className="text-xl font-semibold text-white text-center">
              No books found.
            </h4>
          ) : (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-[#022C4E] text-white rounded-md overflow-hidden">
                <thead>
                  <tr className="bg-[#00406B] text-left">
                    <th className="py-3 px-4">ID</th>
                    <th className="py-3 px-4">Image</th>
                    <th className="py-3 px-4">Title</th>
                    <th className="py-3 px-4">Author</th>
                    <th className="py-3 px-4">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {books.map((book) => (
                    <tr key={book.id} className="border-b border-[#1a3c5a]">
                      <td className="py-3 px-4">{book.id}</td>
                      <td className="py-3 px-4">
                        {book.image ? (
                          <img
                            src={`${import.meta.env.VITE_API_BASE_URL}/storage/${book.image}`}
                            alt={book.title}
                            className="w-16 h-16 object-cover rounded"
                          />
                        ) : (
                          <span className="text-gray-400">No Image</span>
                        )}
                      </td>
                      <td className="py-3 px-4">{book.title}</td>
                      <td className="py-3 px-4">{book.author_name}</td>
                      <td className="py-3 px-4">
                        <button
                          onClick={() => handleDelete(book.id)}
                          className="bg-red-600 hover:bg-red-700 text-white py-1 px-3 rounded"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <BookCreateModal
          setIsModalOpen={setIsModalOpen}
          onBookCreated={fetchBooks} // Pass callback to refresh list
        />
      )}
    </div>
  );
};

export default Book;
